// extracted by mini-css-extract-plugin
export default {"editButton":"fixedAllowance_editButton__jnSge","TableBody":"fixedAllowance_TableBody__k1CdS"};